import React, { useEffect, useState } from "react";
import { Alert } from "../";
import { Schedule } from "./";
import { FiZap, FiClock, FiPower, FiToggleLeft, FiSun, FiMoon } from "react-icons/fi";
import { limitList } from "../../api";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";

const WidgetCommands = ({ zone }) => {
  const { t } = useTranslation();
  const [openScheduleModal, setOpenScheduleModal] = useState(false);
  const toggleSchedule = () => setOpenScheduleModal(!openScheduleModal);
  const [command, setCommand] = useState();
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });
  const token = Cookies.get("token");

  const commandClicked = (command) => {
    if (!command.didactic) {
      toggleSchedule();
      setCommand(command);
    } else {
      setShowAlert((prevState) => ({
        ...prevState,
        show: true,
        message: t("زمانبندی برای این Command مجاز نمی باشد."),
        type: "Warning",
      }));
      setTimeout(() => {
        setShowAlert((prevState) => ({
          ...prevState,
          show: false,
        }));
      }, 3000);
    }
  };

  useEffect(() => {
    limitList(token).then((result) => {
      if (!result.data.data.schedule_limit) {
        setShowAlert((prevState) => ({
          ...prevState,
          show: true,
          message: t(" سقف مجاز برای زمانبندی به اتمام رسیده است."),
          type: "Error",
        }));
        setTimeout(() => {
          setShowAlert((prevState) => ({
            ...prevState,
            show: false,
          }));
        }, 3000);
      }
    });
  }, []);

  return (
    <>
      {!openScheduleModal ? (
        <div className="setting-container" style={{ minHeight: "auto", padding: "24px" }}>
          <h2 className="setting-title">{t("ایجاد زمانبندی")}</h2>

          {/* Commands Grid */}
          <div className="commands-grid">
            {zone.commands?.map((commandItem, index) => {
              // Get icon based on command type
              const isOn = commandItem.command === "11";
              
              return (
                <div
                  key={index}
                  onClick={() => commandClicked(commandItem)}
                  className="command-card"
                >
                  <div className="command-icon">
                    <FiPower size={28} />
                  </div>
                  <p className="command-label">
                    {commandItem.command == "11"
                      ? t("خروجی 1 - خاموش")
                      : t("خروجی 1 - روشن")}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <Schedule
          zone={zone}
          command={command}
          toggleSchedule={toggleSchedule}
        />
      )}

      {showAlert.show && (
        <Alert message={showAlert.message} type={showAlert.type} />
      )}
    </>
  );
};

export { WidgetCommands };